export default __webpack_public_path__ + "static/media/BannerTrovity.18d69c7d.svg";